import React from 'react'
import { Link, browserHistory } from 'react-router'
import initialStateMap from '../data/map'
import { __ } from '../lib/helpers'

const propTypes = {
  unsetSelectedEntity: React.PropTypes.func.isRequired,
}

class Search extends React.Component {

  constructor(props) {
    super(props)

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.geocodeAddress = this.geocodeAddress.bind(this)
    this.handleGeocodeAddress = this.handleGeocodeAddress.bind(this)
    this.autoHideError = this.autoHideError.bind(this)
    this.initAutocomplete = this.initAutocomplete.bind(this)
    this.handleClearance = this.handleClearance.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleFocus = this.handleFocus.bind(this)
        
    this.state = {
      errorMessage: null,
      acBounds: null,
      classClearance: 'Searchfield-cleaner--hide'
    }
  }

  componentDidMount() {
    this.geocoder = new google.maps.Geocoder()
    
    if ( window.innerWidth <= 560 ) {
      document.getElementById('clearanceButton').style.width = '0px'
      document.getElementById('clearanceButton').style.padding = '0px'
      document.getElementById('searchInputField').style.width = '0px'
    }
      
    this.initAutocomplete()
    
  }

  handleKeyDown() {
    if (this.state.errorMessage) {
      this.setState({
        errorMessage: null,
      })
    }
  }
    
  handleClearance() {
      this.address.value = ""
      this.setState({
        classClearance: 'Searchfield-cleaner--hide'
      })
      document.getElementById('searchInputField').focus()
  }
    
  handleFocus() {
    setTimeout(function () { 
      this.address.setSelectionRange(0, this.address.value.length)
    }.bind(this), 50)
  }
    
  handleInput() {
      if(this.address.value.length == 0) {
        this.setState({
         classClearance: 'Searchfield-cleaner--hide'
        })
      } else {
        this.setState({
          classClearance: 'Searchfield-cleaner'
        })
      }
  }

  handleSubmit(event) {
    if (event) {
      event.preventDefault()
    }

    this.props.unsetSelectedEntity()

    let address = this.address.value.trim()

    if ( window.innerWidth > 560 ) {
      this.geocodeAddress(address)
      document.getElementById('searchInputField').blur()
    } else if ( document.getElementById('searchInputField').style.width == '0px' ) {
      document.getElementById('searchInputField').style.width = '260px'
      document.getElementById('searchInputField').style.padding = '11px 5%'
      document.getElementById('searchSubmitButton').style.borderBottomLeftRadius = '0px'
      document.getElementById('searchSubmitButton').style.borderTopLeftRadius = '0px'
      document.getElementById('clearanceButton').style.width = '32px'
      document.getElementById('clearanceButton').style.padding = '8px'
      document.getElementById('searchInputField').focus()
    } else if ( address.trim() == '' ) {
      this.setState({
        errorMessage: __('Search.errorEmpty'),
      })
      return
    } else {
      this.geocodeAddress(address)
      document.getElementById('searchInputField').blur()
      document.getElementById('searchInputField').style.width = '0px'
      document.getElementById('searchInputField').style.padding = '11px 0px'
      document.getElementById('searchSubmitButton').style.borderBottomLeftRadius = '3px'
      document.getElementById('searchSubmitButton').style.borderTopLeftRadius = '3px'
      document.getElementById('clearanceButton').style.width = '0px'
      document.getElementById('clearanceButton').style.padding = '0px'
    }
  }
    
  autoHideError() {
    setTimeout(function() { 
      this.setState({
        errorMessage: null,
      })
    }.bind(this), 3000)
  }

  render() {

    let label
    if (this.props.label) {
      label = <label className="Search-label">{this.props.label}</label>
    }

    const placeholder = __('Search.placeholder')

    let error 
    if (this.state.errorMessage) {
      error = <div className="Search-error">{this.state.errorMessage}</div>
      this.autoHideError()
    }
      
    return (
      <div className="Search Search--inline">
        <form className="Search-form" onSubmit={this.handleSubmit}>
          {label}
          <input 
            className="Search-input"
            id="searchInputField"
            ref={(address) => this.address = address} 
            type="text" 
            name="postal-code" 
            autoComplete="off"
            placeholder={ __('Search.placeholder') }
            onKeyDown={this.handleKeyDown}
            onInput={this.handleInput}
            onFocus={this.handleFocus}
          />
          <a
            className={this.state.classClearance}
            id="clearanceButton"
            onClick={this.handleClearance}
          />
          <input 
            className="Search-submit"
            id="searchSubmitButton"
            type="submit" 
            name="submit"
            value=""
          />
        </form>
        {error}
      </div>
    )
  }

  initAutocomplete() {
    this.autocompleteFormField = document.getElementById('searchInputField')
    const autocomplete = new google.maps.places.Autocomplete((this.autocompleteFormField), {
        types: ['(regions)']
    })

    this.autocompleteListener = google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace()
      if (place.geometry) {
        this.setState({
          acBounds: place.geometry.viewport
        })
      }
      this.handleSubmit()
    })
  }

  geocodeAddress(address) {
    if (address.trim() == '') {
      this.setState({
        errorMessage: __('Search.errorEmpty'),
      })
      return
    }

    this.setState({
      errorMessage: null,
    })
      //console.log('address: ', address)
    this.geocoder.geocode({'address': address}, this.handleGeocodeAddress)
  }

  handleGeocodeAddress(results, status) {
      //console.log('results: ', results)
      //console.log('status: ', status)
    if (status === google.maps.GeocoderStatus.OK && results[0].geometry.bounds) {
      //console.log('USED SEARCH-BOUNDS')
      window.scrollTo(0, 0)

      const bounds = {
        west: results[0].geometry.bounds.getSouthWest().lng(),
        south: results[0].geometry.bounds.getSouthWest().lat(),
        east: results[0].geometry.bounds.getNorthEast().lng(),
        north: results[0].geometry.bounds.getNorthEast().lat()
      }

      if( bounds.east - bounds.west < 0.07 && bounds.north - bounds.south < 0.03 ){
            let deltaLatCorrection = (0.07 - (bounds.east - bounds.west))/2
            let deltaLngCorrection = (0.03 - (bounds.north - bounds.south))/2
            const boundsCorrection = {
                west: bounds.west - deltaLatCorrection,
                south: bounds.south - deltaLngCorrection,
                east: bounds.east + deltaLatCorrection,
                north: bounds.north + deltaLngCorrection
            }

            this.props.setBounds(boundsCorrection)
          
        } else {
            
            this.props.setBounds(bounds)
            
        }

    } else if (status === google.maps.GeocoderStatus.OK && !results[0].geometry.bounds && results[0].geometry.viewport) {
        //console.log('ONLY VIEWPORT!')
        window.scrollTo(0, 0)

        const viewportBounds = {
          west: results[0].geometry.viewport.getSouthWest().lng(),
          south: results[0].geometry.viewport.getSouthWest().lat(),
          east: results[0].geometry.viewport.getNorthEast().lng(),
          north: results[0].geometry.viewport.getNorthEast().lat()
        }
        
        if( viewportBounds.east - viewportBounds.west < 0.07 && viewportBounds.north - viewportBounds.south < 0.03 ){
            let deltaLatCorrectionVP = (0.07 - (viewportBounds.east - viewportBounds.west))/2
            let deltaLngCorrectionVP = (0.03 - (viewportBounds.north - viewportBounds.south))/2
            const viewportBoundsCorrection = {
                west: viewportBounds.west - deltaLatCorrectionVP,
                south: viewportBounds.south - deltaLngCorrectionVP,
                east: viewportBounds.east + deltaLatCorrectionVP,
                north: viewportBounds.north + deltaLngCorrectionVP
            }
            
            this.props.setBounds(viewportBoundsCorrection)
        } else {
            
            this.props.setBounds(viewportBounds)
            
        }
        
    } else if (this.state.acBounds !== null) {
        //console.log('USED AUTOCOMPLETE-BOUNDS')
        const acBounds = {
            west: this.state.acBounds.getSouthWest().lng(),
            south: this.state.acBounds.getSouthWest().lat(),
            east: this.state.acBounds.getNorthEast().lng(),
            north: this.state.acBounds.getNorthEast().lat()
        }
        this.setState({
            acBounds: null,
        })
        this.props.setBounds(acBounds)
        
    } else {
      // console.log('Geocode was not successful for the following reason: ' + status)

      this.setState({
        errorMessage: __('Search.errorNotFound'),
      })
    }
  }
}

Search.propTypes = propTypes

export default Search


// WEBPACK FOOTER //
// ./src/components/Search.js